import React, { useContext } from 'react';

import { SkeletonLine } from 'src/components/Helpers/SkeletonLine';

import { Button } from '../Button/Button';
import { Svg } from '../Svg/Svg';

import { FilterModalContext } from './FilterModalContext';
import classes from './Toolbar.scss';

type ToolbarLayoutProps = {
    currentFilters?: React.ReactNode;
    loading?: boolean;
    sorter?: React.ReactNode;
    stats: React.ReactNode;
    totalSelections: number;
};

export function ToolbarLayout(props: ToolbarLayoutProps) {
    const { openFilter } = useContext(FilterModalContext);
    const totalSelections = props.totalSelections;
    const totalSelectionsText = totalSelections > 0 ? `(${totalSelections})` : undefined;
    return (
        <div className={classes.root}>
            <div className={classes.inner}>
                <div className={classes.filter}>
                    <Button onClick={openFilter} icon="right-of-text" variant="light" className={classes.btn}>
                        <span>
                            <b>Filter</b> {totalSelectionsText}
                        </span>
                        <Svg name="filter" />
                    </Button>
                </div>
                {props.sorter && <div className={classes.sort}>{props.sorter}</div>}
            </div>

            <div className={classes.filterCurrent}>{props.currentFilters}</div>

            <div className={classes.count}>
                {props.loading && <SkeletonLine width={10} />}
                {!props.loading && props.stats}
            </div>
        </div>
    );
}
